import { Routes } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { canDeactivateGuard } from '@ui-core/guards/alert-unsaved-changes.guard'
import { AuthGuard } from '@ui-core/guards/auth.guard'

export const honeyTypesRoutes: Routes = [

    {
        path: RoutesEnum.HONEY_TYPES,
        loadComponent: () => import('./honey-types').then((m) => m.HoneyTypes),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    }
]
